// extracted by mini-css-extract-plugin
export var productImage = "_zu-0";